import { json2csv_fn } from "@/utils/common";
import locale from "@/helpers/locale";
import moment from 'moment';
import { getExportName_fn } from '@/utils/common'

export function exportCSV_fn(csvData, date, weekLocaleArray, cinemaName) {
    const fields = [
		{
			label: locale("global.titleOfWork"),
			value: "film",
		},
		{
			label: locale("global.screenStandard"),
			value: "version",
		},
		{
			label: locale("trans.report.version.caption"),
			value: "subtitlesVersion",
		},
		{
			label: locale("global.otherVersions"),
			value: "otherVersion",
		},
        {
            label: locale('report.preSalesDaily.showdate'),
            value: "upcomingDate",
        },
        {
            label: locale('report.preSalesDaily.showtime'),
            value: "showTime",
        },
		{
			label: locale("global.screen"),
			value: "house",
		},
		{
			label: locale("report.preSalesDaily.grouping"),
			value: "baseType",
		},
		{
			label: locale("global.sale"),
			value: "sale",
		},
		{
			label: locale("trans.report.ticketTypeName"),
			value: "ticketType",
		},
		{
			label: locale("global.cost"),
			value: "ticketPrice",
		},
		{
			label: locale("arriveDaily.total.ticketType") + locale('cashierReport.dialog.th.cashQty'),
			value: "ticketQty",
		},
		{
			label: locale("arriveDaily.total.ticketType") + locale('cashierReport.dialog.th.amount'),
			value: "ticketAmount",
		},
	];
	json2csv_fn(csvData, fields, 
	// moment().format("YYYYMMDDHHmm") + "_" + locale("sideMenu.reports.bookingDaily")
	getExportName_fn(
		locale("sideMenu.reports.bookingDaily"),
		'',
		'',
		'',
		`${moment(date).format('YYYY-MM-DD')} （${weekLocaleArray[moment(date).day()]}）`,
		cinemaName,
		moment().format('YYYYMMDDHHmm')
	)
	);
}